import { render } from "./Confirm.vue?vue&type=template&id=31aacbf4&scoped=true&ts=true"
import script from "./Confirm.vue?vue&type=script&lang=ts"
export * from "./Confirm.vue?vue&type=script&lang=ts"

import "./Confirm.vue?vue&type=style&index=0&id=31aacbf4&lang=postcss&scoped=true"

import exportComponent from "/builds/wVusKqw4/1/kenniss/platform/educator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31aacbf4"]])

export default __exports__